/**
 * @generated SignedSource<<ef7fdfd9aed7db9f21304f729aa946d4>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterModel"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fromDate"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shiftsFilter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "toDate"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "where"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "whereSchedules"
    }, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v7 = [
        (v6 /*: any*/)
    ], v8 = {
        "kind": "Variable",
        "name": "filterModel",
        "variableName": "filterModel"
    }, v9 = {
        "kind": "Variable",
        "name": "fromDate",
        "variableName": "fromDate"
    }, v10 = {
        "kind": "Variable",
        "name": "toDate",
        "variableName": "toDate"
    }, v11 = {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
    }, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schedulable",
        "storageKey": null
    }, v13 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "shiftsFilter"
        },
        {
            "fields": [
                (v9 /*: any*/),
                (v10 /*: any*/)
            ],
            "kind": "ObjectValue",
            "name": "model"
        },
        (v11 /*: any*/)
    ], v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entityDisabled",
        "storageKey": null
    }, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "RunningSchedulesPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Company",
                    "kind": "LinkedField",
                    "name": "currentCompany",
                    "plural": false,
                    "selections": (v7 /*: any*/),
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrentUser",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/),
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "RunningSchedulesHeaderMobile_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "args": [
                        (v8 /*: any*/),
                        (v9 /*: any*/),
                        {
                            "kind": "Variable",
                            "name": "shiftsFilter",
                            "variableName": "shiftsFilter"
                        },
                        (v10 /*: any*/),
                        (v11 /*: any*/),
                        {
                            "kind": "Variable",
                            "name": "whereSchedules",
                            "variableName": "whereSchedules"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "RunningSchedulesGrid_schedules"
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RunningSchedulesHeader_query"
                },
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "RunningSchedulesInformationDrawer"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/),
                (v2 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "RunningSchedulesPageQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Company",
                    "kind": "LinkedField",
                    "name": "currentCompany",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompanyScheduleSettings",
                            "kind": "LinkedField",
                            "name": "scheduleSettings",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "viewAccessUntil",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "CurrentUser",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                (v6 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SchedulableUser",
                                    "kind": "LinkedField",
                                    "name": "schedulableEntity",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v12 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v6 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": "gridSchedules",
                    "args": [
                        (v8 /*: any*/),
                        {
                            "kind": "Variable",
                            "name": "where",
                            "variableName": "whereSchedules"
                        }
                    ],
                    "concreteType": "ScheduleConnection",
                    "kind": "LinkedField",
                    "name": "schedules",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ScheduleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Schedule",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "currentUserPermissions",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v13 /*: any*/),
                                            "concreteType": "ScheduleShiftConnection",
                                            "kind": "LinkedField",
                                            "name": "runningSchedule",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleShiftEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ScheduleShift",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "assignmentTypeId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "end",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "start",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AssignmentType",
                                                                    "kind": "LinkedField",
                                                                    "name": "assignmentType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v6 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "title",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "assignedEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v14 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v6 /*: any*/),
                                                                                (v15 /*: any*/),
                                                                                (v12 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "User",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v6 /*: any*/),
                                                                                        (v16 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "fullName",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "SchedulableUser",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                (v6 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Asset",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "asset",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v6 /*: any*/),
                                                                                        (v16 /*: any*/),
                                                                                        (v17 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v15 /*: any*/),
                                                                                (v12 /*: any*/)
                                                                            ],
                                                                            "type": "SchedulableAsset",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": (v7 /*: any*/),
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "assignedEntityId",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "isVacant",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "status",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Event",
                                                                    "kind": "LinkedField",
                                                                    "name": "event",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v6 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isWork",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isAbsence",
                                                                            "storageKey": null
                                                                        },
                                                                        (v17 /*: any*/),
                                                                        (v16 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v14 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "cursor",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "endCursor",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": (v13 /*: any*/),
                                            "filters": [],
                                            "handle": "connection",
                                            "key": "RuningSchedulesGridSchedule_runningSchedule",
                                            "kind": "LinkedHandle",
                                            "name": "runningSchedule"
                                        },
                                        {
                                            "alias": null,
                                            "args": (v13 /*: any*/),
                                            "filters": [],
                                            "handle": "connection",
                                            "key": "RunningSchedulesGridHeader_runningSchedule",
                                            "kind": "LinkedHandle",
                                            "name": "runningSchedule"
                                        },
                                        (v17 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "where",
                            "value": {
                                "isAbsence": {
                                    "eq": true
                                }
                            }
                        }
                    ],
                    "concreteType": "EventConnection",
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        (v17 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "events(where:{\"isAbsence\":{\"eq\":true}})"
                }
            ]
        },
        "params": {
            "cacheID": "ce40a08004ba8293a6263d47b1c8a0de",
            "id": null,
            "metadata": {},
            "name": "RunningSchedulesPageQuery",
            "operationKind": "query",
            "text": "query RunningSchedulesPageQuery(\n  $fromDate: DateTime!\n  $toDate: DateTime!\n  $where: ScheduleShiftFilterInput\n  $whereSchedules: ScheduleFilterInput\n  $shiftsFilter: ScheduleShiftsFilterInput\n  $filterModel: ScheduleFilterRequestInput\n) {\n  currentCompany {\n    id\n  }\n  currentUser {\n    me {\n      id\n      ...RunningSchedulesHeaderMobile_user\n    }\n    id\n  }\n  ...RunningSchedulesGrid_schedules_18VVRY\n  ...RunningSchedulesHeader_query\n  ...RunningSchedulesInformationDrawer\n}\n\nfragment RunningSchedulesGridHeader_schedule_2fp1si on Schedule {\n  id\n  runningSchedule(model: {fromDate: $fromDate, toDate: $toDate}, where: $where, filter: $shiftsFilter) {\n    edges {\n      node {\n        id\n        assignmentTypeId\n        assignmentType {\n          id\n          title\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  name\n}\n\nfragment RunningSchedulesGridSchedule_schedule_2fp1si on Schedule {\n  runningSchedule(model: {fromDate: $fromDate, toDate: $toDate}, where: $where, filter: $shiftsFilter) {\n    edges {\n      node {\n        id\n        assignmentTypeId\n        end\n        start\n        assignmentType {\n          id\n          title\n        }\n        assignedEntity {\n          __typename\n          ... on SchedulableUser {\n            id\n          }\n          ... on SchedulableAsset {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        ...ScheduleShift_shift\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n  name\n  currentUserPermissions\n}\n\nfragment RunningSchedulesGrid_schedules_18VVRY on Query {\n  gridSchedules: schedules(where: $whereSchedules, filterModel: $filterModel) {\n    edges {\n      node {\n        id\n        currentUserPermissions\n        ...RunningSchedulesGridSchedule_schedule_2fp1si\n        ...RunningSchedulesGridHeader_schedule_2fp1si\n        runningSchedule(model: {fromDate: $fromDate, toDate: $toDate}, where: $where, filter: $shiftsFilter) {\n          edges {\n            node {\n              id\n              assignmentType {\n                id\n                title\n              }\n            }\n          }\n        }\n        name\n      }\n    }\n  }\n}\n\nfragment RunningSchedulesHeaderMobile_user on User {\n  ...ScheduleSwitch_user\n}\n\nfragment RunningSchedulesHeader_query on Query {\n  currentCompany {\n    scheduleSettings {\n      id\n      viewAccessUntil\n    }\n    id\n  }\n}\n\nfragment RunningSchedulesInformationDrawer on Query {\n  events(where: {isAbsence: {eq: true}}) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment SchedulableAsset_entity on SchedulableAsset {\n  id\n  asset {\n    id\n    color\n    name\n  }\n  entityDisabled\n  schedulable\n}\n\nfragment SchedulableUser_entity on SchedulableUser {\n  id\n  entityDisabled\n  schedulable\n  user {\n    id\n    color\n    fullName\n  }\n}\n\nfragment ScheduleShift_shift on ScheduleShift {\n  id\n  assignedEntity {\n    ... on SchedulableAsset {\n      id\n      ...SchedulableAsset_entity\n    }\n    ... on SchedulableUser {\n      id\n      ...SchedulableUser_entity\n    }\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignedEntityId\n  assignmentType {\n    id\n    title\n  }\n  end\n  start\n  isVacant\n  status\n  event {\n    id\n    isWork\n    isAbsence\n    name\n    color\n  }\n}\n\nfragment ScheduleSwitch_user on User {\n  schedulableEntity {\n    id\n    schedulable\n  }\n}\n"
        }
    };
})();
node.hash = "5b68b98918590e65fd2affc04f984773";
export default node;
